import React from 'react';
import { Message } from 'semantic-ui-react';
import '../localization/config';
import { useTranslation } from 'react-i18next';
import { ResourceData } from '../providers/ResourcesProvider';
import { getActivityIcon } from '../utility';
import moment from 'moment/moment';

export interface IResourceHistory {
  resource: ResourceData;
}

const styles = {
  historyContainer: {
    overflow: 'auto',
    maxHeight: '50vh'
  }
}

const ResourceHistory = (props: IResourceHistory) => {
  const { t } = useTranslation();

  return (
    <div style={styles.historyContainer}>
      {props.resource.history.map((action, idx) => {
        return (
          <Message
            key={idx}
            icon={getActivityIcon(action.action)}
            header={`${t(`activityTypes.${action.action}`)} ${t(
              'resources.byUser'
            )} ${action.userName} ${t('general.on')} ${moment(
              action.date
            ).format('LLL')}`}
            content={action.message}
          />
        );
      })}
    </div>
  );
};

export default ResourceHistory;
